import React, { useCallback } from 'react';
import { isNull } from 'lodash/fp';

import { useAppDispatch, useAppSelector } from '../../../../hooks/react-redux';
import { SingleField } from '../fields/SingleField';
import { getOpenFieldsAndSections, toggleOpenFieldSection } from '../store';
import { TakerSFTDocuments, UpdatedOpinionField } from '../store/types';
import styles from './OpinionSection.module.scss';
import { SectionWrapper } from './SectionWrapper';

interface TakerSFTDocumentsProps {
    sftDocuments: TakerSFTDocuments;
    previousSftDocuments: TakerSFTDocuments | null;
    isEditing: boolean;
    isUpdating: boolean;
    fieldsUpdated: UpdatedOpinionField[];
}

export const TakerSFTDocumentsSection: React.FC<TakerSFTDocumentsProps> = ({ sftDocuments, previousSftDocuments, isEditing, isUpdating, fieldsUpdated }) => {
    const dispatch = useAppDispatch();
    const openFieldsAndSections = useAppSelector(getOpenFieldsAndSections);
    const getFieldOpen = useCallback((id: string) => openFieldsAndSections.includes(id), [openFieldsAndSections]);
    const toggleFieldOpen = useCallback((id: string) => dispatch(toggleOpenFieldSection(id)), [dispatch]);
    const sectionId = 'sftDocuments';
    const { loanTransactions, koreanPledge } = sftDocuments;

    const getPreviousField = useCallback((fieldId: keyof TakerSFTDocuments) => !isNull(previousSftDocuments) && previousSftDocuments[fieldId] || null, [previousSftDocuments]);

    return (
        <SectionWrapper id={sectionId} label='SFT Documents' isEditing={isEditing} isUpdating={isUpdating}>
            <div className={styles.takerSFTDocumentsSectionWrapper}>
                <div className={styles.sectionHeaderLabel}>Under the laws of the jurisdiction under consideration:</div>
                <SingleField
                    field={loanTransactions}
                    previousField={getPreviousField('loanTransactions')}
                    fieldId='loanTransactions'
                    sectionId={sectionId}
                    isEditing={isEditing}
                    isUpdating={isUpdating}
                    fieldsUpdated={fieldsUpdated}
                    getFieldOpen={getFieldOpen}
                    toggleFieldOpen={toggleFieldOpen}
                    positiveAnswers={['No']}
                    negativeAnswers={['Yes', 'Yes - with exceptions']}
                />
                <SingleField
                    field={koreanPledge}
                    previousField={getPreviousField('koreanPledge')}
                    fieldId='koreanPledge'
                    sectionId={sectionId}
                    isEditing={isEditing}
                    isUpdating={isUpdating}
                    fieldsUpdated={fieldsUpdated}
                    getFieldOpen={getFieldOpen}
                    toggleFieldOpen={toggleFieldOpen}
                    positiveAnswers={['No']}
                    negativeAnswers={['Yes', 'Yes - with exceptions']}
                />
            </div>
        </SectionWrapper>
    );
};
